import 'css-chunksrc/client/pages/exportsPage/wbsReport/filters/styles.scss';export default {
  "filters": "_filters_jo03i_1",
  "resetButton": "_resetButton_jo03i_17",
  "label": "_label_jo03i_25",
  "section": "_section_jo03i_32"
};